import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import UI_ORGANIZATION_DETAILS_PAGE_QUERY from '@jira/servicedesk__organization-details/src/__generated__/OrganizationDetailsOrganizationDetailsPageQuery$parameters.ts';
// eslint-disable-next-line jira/import-whitelist
import UI_ORGANIZATION_DETAILS_PAGE_CSM_QUERY from '@jira/servicedesk__organization-details/src/__generated__/OrganizationDetailsOrganizationDetailsPageCsmQuery$parameters.ts';
import type { OrganizationDetailsOrganizationDetailsPageQuery } from '@jira/servicedesk__organization-details/src/__generated__/OrganizationDetailsOrganizationDetailsPageQuery.graphql.ts';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';

const getCustomerServiceOrganizationAri = (
	organizationId: string,
	activationId: string,
): string => {
	return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};

export const OrganizationDetailsPageQueryResource: RouteResource<
	PreloadedQuery<OrganizationDetailsOrganizationDetailsPageQuery, Record<string, unknown>>
> = createRelayResource<OrganizationDetailsOrganizationDetailsPageQuery>({
	type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
	getQuery: ({ match }, { tenantContext }) => ({
		// Endpoint migration (BERRY-2444): preload the csm_ endpoint query when the
		// gate is on, else the deprecated one. The page component selects the matching
		// document via the same gate. Both share identical variables. The csm params are
		// cast to the resource's query type (the two operations Relay can't unify).
		parameters: fg('csm_native_assets_field_customer_context')
			? // oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
				(UI_ORGANIZATION_DETAILS_PAGE_CSM_QUERY as any)
			: UI_ORGANIZATION_DETAILS_PAGE_QUERY,
		variables: {
			organizationId: getCustomerServiceOrganizationAri(
				String(match.params.organizationId),
				tenantContext.activationId,
			),
			cloudId: tenantContext.cloudId,
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
